import { createFileRoute } from '@tanstack/react-router'
import LazyRoute from '@/components/LazyRoute'

export const Route = createFileRoute('/_protected/organization/settings/usage')({
  component: () => (
    <LazyRoute
      loader={() => import('@/components/organization-settings/usage')}
      fallback={<div>Loading...</div>}
    />
  ),
})